import { DiagramDrawingColorName } from '../../../../typings/drawing-palettes';

export const convertColorNameToHtmlColorValue = (
  colorName: DiagramDrawingColorName,
): HtmlColorValue => `var(--cui-${colorName})`;
